<template>
  <div>
    <Modal v-model="rechargeModal" :title="$t('key1005898')" width="800" class-name="rechargeStyles"
      :transfer="false" :mask-closable="false" @on-visible-change="rechargeChange">
      <Form ref="formInline" :model="formInline" :rules="ruleInline" :label-width="labelWidth" @submit.native.prevent>
        <Row style="width: 90%;">
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1001490')" prop="paymentType" class="radio_styles" v-if="offlinePaymentFlag">
              <RadioGroup v-model="formInline.paymentType" @on-change="paymentTypeChange">
                <Radio class="mr45" v-for="item in paymentTypeList" :key="item.value" :label="item.value">{{ item.name }}</Radio>
              </RadioGroup>
            </FormItem>
          </Col>
          <!--线下支付模式-->
          <div v-show="formInline.paymentType === 2">
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem prop="totalAmount" :label="$t('key1003785')" class="amount-list required_style_label">
                <div class="flex align-items-center">
                  <span class="amount-box" v-for="(item,index) in amount" @click="selectAmountType(index)"
                    :class="{'active-box':index === activeAmountType}">
                    {{ item }}
                  </span>
                  <div>
                    <Input v-if="activeAmountType === null" clearable class="other-amount" ref="otherAmount" @on-blur="blurChange"
                      v-model.trim="formInline.totalAmount"/>
                    <span v-else class="other-box" @click="clickOtherBox">{{ $t('key1005899') }}</span>
                  </div>
                </div>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1001491')" prop="channel">
                <Select v-model="formInline.channel" filterable transfer style="width:300px;" @on-change="changeChannel">
                  <Option v-for="(item, index) in paymentChannelsList" :value="item.channel" :key="index">{{ item.channel }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="formInline.channel">
              <FormItem :label="$t('key1001492')" prop="account">
                <div class="flex align-items-center">
                  <Select v-model="formInline.account" filterable transfer style="width:300px;" @on-change="changeAccount">
                    <Option v-for="(item, index) in accountList" :value="item.account" :key="index">{{ item.account }}</Option>
                  </Select>
                  <span class="ml20" :class="formInline.account ? 'themeColor cursor' : ''" @click="viewCompleteMessage">{{ $t('key1001503') }}</span>
                </div>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-show="formInline.account">
              <FormItem :label="$t('key1001493')" prop="receiveTotalPrice">
                <div class="flex-direction">
                  <Input disabled v-model.trim="totalPayableAmount" style="width:300px;"></Input>
                  <p class="width_300 text-align-right font-size-12" v-if="formInline.channel && formInline.account && formInline.totalAmount">
                    {{ $t('key1001496') + formInline.receiveTotalPrice + ' ' + formInline.targetCurrency }}
                  </p>
                </div>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1001494')" prop="imagePaths" class="required_style_label">
                <div class="flex align-items-center">
                  <template v-if="formInline.imagePaths.length >0">
                    <div class="img_style" v-for="(url, index) in formInline.imagePaths" v-viewer="viewerOptions">
                      <img :src="setImgPath(url)" alt=""/>
                      <Icon type="ios-close-circle" class="del-icon" @click.stop="delProductImages(index)"/>
                    </div>
                  </template>
                  <Upload
                    v-if="formInline.imagePaths.length < 5"
                    class="upload_styles"
                    ref="upload"
                    type="drag"
                    name="files"
                    multiple
                    :headers="headObj"
                    :action="fileApi"
                    :data="uploadData"
                    :show-upload-list="false"
                    :on-success="uploadSuccess"
                    :format="['jpg', 'jpeg', 'png']"
                    :max-size="5120"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize">
                    <div class="upload_icon_box">
                      <Icon type="ios-cloud-upload" size="45" style="color: #3399ff"></Icon>
                      <p>{{ $t('key1000465') }}</p>
                    </div>
                  </Upload>
                </div>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1001495')" prop="remark">
                <Input type="textarea" :showWordLimit="true" :maxlength="200"
                  :autosize="{ minRows: 4, maxRows: 6}" v-model.trim="formInline.remark">
                </Input>
              </Form-item>
            </Col>
            <p class="font-size-13 color-999 mb20 ml20">
              <span>{{ $t('key1000615') }}</span>
              <span>{{ $t('key1001504') }}</span>
            </p>
          </div>
          <!--在线支付模式-->
          <div v-show="formInline.paymentType ===1">
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem prop="totalAmount" :label="$t('key1003785')" class="amount-list required_style_label">
                <div class="flex align-items-center">
                  <span class="amount-box" v-for="(item,index) in amount" @click="selectAmountType(index)"
                    :class="{'active-box':index === activeAmountType}">
                    {{ item }}
                  </span>
                  <div>
                    <Input v-if="activeAmountType === null" clearable class="other-amount" ref="otherAmount" @on-blur="blurChange"
                      v-model.trim="formInline.totalAmount" @on-enter="rechargeBtn"/>
                    <span v-else class="other-box" @click="clickOtherBox">{{ $t('key1005899') }}</span>
                  </div>
                </div>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem prop="payType" :label="$t('key1000612')">
                <RadioGroup v-model="formInline.payType">
                  <Radio label="alipay">
                    <img class="alipay-logo" src="@/assets/images/pay/alipay.png" width="120" alt=""/>
                  </Radio>
                  <!--<Radio label="payoneer">
                    <img class="payoneer-logo" src="@/assets/images/pay/payoneer.png" width="120"/>
                  </Radio>-->
                </RadioGroup>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1003783')" prop="currency">
                <Select v-model="formInline.currency" transfer filterable disabled>
                  <Option v-for="(item, index) in currencyListData" :key="index" :value="item.value">{{ item.label }}</Option>
                </Select>
                <div class="mt10" style="font-size: 13px;" v-if="currencyTalg">
                  <p style="line-height: 20px;">{{ currentExchangeRate }}</p>
                  <p style="line-height: 20px;">{{ actualAmount }}</p>
                </div>
              </Form-item>
            </Col>
          </div>
        </Row>
      </Form>
      <template #footer>
        <Button @click="rechargeModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="rechargeBtn" :loading="payLoading">{{ $t('key1000111') }}</Button>
      </template>
    </Modal>
    <!--账户完整信息弹窗-->
    <completeAccountInfoModal ref="completeAccountInfo"></completeAccountInfoModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {
  amountHandel, commonLocalStorage, currencyNameCode, getPaymentChannelsData,
  getCurrencyConversion, clearFormFieldValidate
} from "@/utils/common";
import completeAccountInfoModal from "@/views/distributor/components/orderManage/completeAccountInfoModal.vue";

export default {
  name: 'rechargeModal',
  mixins: [Mixin],
  data() {
    let v = this;
    // 金额校验
    const validateAmount = (rule, value, callback) => {
      const totalAmount = Number(v.formInline.totalAmount);
      if (!totalAmount) {
        return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005893')));
      }
      if (isNaN(totalAmount)) {
        return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005894')));
      }
      if (totalAmount <= 0) {
        return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005895')));
      }
      if (totalAmount > 100000000) {
        return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005896')));
      }
      callback();
    };

    return {
      rechargeModal: false,
      formInline: {
        paymentType: 1,
        totalAmount: '',
        payType: 'alipay',
        currency: 'CNY',

        channel: null,
        account: null,
        targetCurrency: null,
        receiveTotalPrice: null,
        imagePaths: [],
        remark: ''
      },
      ruleInline: {
        totalAmount: [
          {validator: validateAmount, trigger: 'change'},
        ],
        channel: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001479'), trigger: 'change'}
        ],
        account: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001480'), trigger: 'change'}
        ]
      },
      payLoading: false,
      activeAmountType: 0,
      amount: [
        '100',
        '500',
        '1000'
      ],
      currency: '',
      currencyTalg: false,
      currentExchangeRate: '',
      actualAmount: '',
      selectCurrencyData: null,

      paymentTypeList: [
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001481')},
        {value: 2, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001482')},
      ],
      offlinePaymentFlag: false,
      paymentChannelsList: [],
      accountList: [],
      fileApi: api.erpCommon_uploadFiles + '?basePath=yms-distributor-service&action="uploadimage"',
      uploadData: {},
      currencyListData: [],
    };
  },
  computed: {
    totalPayableAmount() {
      return this.formInline.totalAmount ? this.formInline.totalAmount + ' ' + this.currencyState : '';
    }
  },
  methods: {
    // 初始化数据
    async initRechargeData() {
      const config = commonLocalStorage.getItem('configurationItemInfo') ?? this.$store.state.configurationItemInfo;
      // 是否开启线下付款
      this.offlinePaymentFlag = Number(config?.offlinePayment) === 1;
      if (this.offlinePaymentFlag) {
        // 获取支付渠道基础数据
        this.paymentChannelsList = await getPaymentChannelsData('?status=1');
      }
      this.getSystemCurrencyData();
      this.formInline.totalAmount = this.getRechargeAmount(this.activeAmountType);
      this.processingRechargeCurrency();
      this.rechargeModal = true;
    },
    // 处理充值币种
    processingRechargeCurrency() {
      let obj = {
        value: 'CNY',
        label: currencyNameCode(this.currencyState, 'currencyCnName')
      };
      this.currencyListData = [obj] || [];
    },
    // 获取当前充值金额
    getRechargeAmount(activeAmountType, totalAmountInput) {
      const amountMap = {
        0: 100,
        1: 500,
        2: 1000
      };
      if (activeAmountType !== null && amountMap.hasOwnProperty(activeAmountType)) {
        return amountMap[activeAmountType];
      }
      // 自定义金额
      let amount = Number(totalAmountInput);
      if (isNaN(amount)) {
        return 0;
      }
      return Math.floor(amount * 100) / 100;
    },
    // 确定
    async rechargeBtn() {
      let fields = ['totalAmount'];
      if (this.formInline.paymentType === 2) {
        fields.push('channel');
        if (this.formInline.channel) fields.push('account');
      }
      const validateField = (field) => {
        return new Promise((resolve) => {
          this.$refs.formInline.validateField(field, (error) => {
            resolve(!error);
          });
        });
      };
      const result = await Promise.all(fields.map(field => validateField(field)));
      const valid = result.every(Boolean);
      if (!valid) {
        return;
      }
      // 手动校验图片
      if (this.formInline.paymentType === 2 && this.formInline.imagePaths.length === 0) {
        this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001485'));
        return;
      }
      // 当前充值金额
      const totalAmount = this.getRechargeAmount(this.activeAmountType, this.formInline.totalAmount);

      // 请求参数
      this.payLoading = true;
      try {
        let params;
        switch (this.formInline.paymentType) {
          case 1:
            params = {
              remarks: '',
              subject: '',
              totalAmount: totalAmount,
              ymsDistributorMerchantRechargeRecordId: null
            }
            await this.alipayPayment(params);
            break;
          case 2:
            params = {
              payType: this.formInline.paymentType,
              totalAmount: this.formInline.totalAmount,
              remarks: '',
              uploadPackagePayVoucherBo: {
                channel: this.formInline.channel,
                account: this.formInline.account,
                distributorMerchantId: this.$store.state.erpConfig.userInfo?.merchantId,
                receiveTotalPrice: this.formInline.receiveTotalPrice,
                currency: this.formInline.targetCurrency,
                imagePaths: this.formInline.imagePaths,
                accountRemark: this.formInline.accountRemark,
                remark: this.formInline.remark
              }
            };
            await this.offlinePayment(params);
            break;
        }
      } finally {
        this.payLoading = false;
      }
    },
    // 支付宝支付
    async alipayPayment(paramsData) {
      try {
        sessionStorage.removeItem('payForm');
        const response = await this.axios.post(api.post_ymsDistributorMerchantRechargeRecord_alipay,
          paramsData, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')});
        if (response.data.code === 0) {
          if (response.data.datas === 'ok') {
            this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003790'));
            this.rechargeModal = false;
            this.$emit('updateData', true);
          } else {
            // 跳转支付页
            sessionStorage.setItem('payForm', response.data.datas);
            this.rechargeModal = false;
            setTimeout(() => {
              window.open('./payCallback.html', '__target');
            }, 100);
          }
        }
      } catch (e) {
        console.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005897'), e);
      } finally {
        this.payLoading = false;
      }
    },
    // 线下支付充值
    async offlinePayment(paramsData) {
      try {
        const response = await this.axios.post(api.post_ymsDistributorMerchantRechargeRecord_offlineRecharge,
          paramsData, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')});
        if (response.data.code === 0) {
          this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
          this.rechargeModal = false;
          this.$emit('updateData', true);
        }
      } catch (e) {
        console.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005897'), e);
      } finally {
        this.payLoading = false;
      }
    },
    // 选择支付金额类型
    selectAmountType(index) {
      this.activeAmountType = index;
      this.$refs.formInline.validateField('totalAmount');
      this.handleEexchangeRate(this.selectCurrencyData);
      this.formInline.totalAmount = this.getRechargeAmount(this.activeAmountType);
      this.changeAccount(this.formInline.account);
    },
    // 其他金额blur事件
    blurChange() {
      if (isNaN(Number(this.formInline.totalAmount))) {
        this.formInline.totalAmount = '';
      }
      if (this.formInline.totalAmount.toString().includes('.')) {
        this.formInline.totalAmount = Math.floor(this.formInline.totalAmount * 100) / 100;
      }
      if (this.formInline.totalAmount) {
        this.handleEexchangeRate(this.selectCurrencyData, this.formInline.totalAmount);
        this.changeAccount(this.formInline.account);
      }
      this.$refs.formInline.validateField('totalAmount');
    },
    // 点击其他金额事件
    clickOtherBox() {
      this.activeAmountType = null;
      this.formInline.totalAmount = '';
      this.$nextTick(() => {
        this.$refs.otherAmount.focus();
      });
    },
    // 获取对应系统设置的币种数据
    systemCurrencyData(currency) {
      let v = this;
      v.selectCurrencyData = null;
      v.axios.get(api.get_ymsCurrencyConfig_query + `?merchantType=3`).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data && data.length > 0) {
            data.map((item) => {
              if (item.targetCurrencyCode === currency) {
                v.currencyTalg = true;
                v.selectCurrencyData = item;
                v.handleEexchangeRate(item);
              }
            });
          }
        }
      });
    },
    // 获取系统配置的币种
    getSystemCurrencyData() {
      let v = this;
      v.currencyTalg = false;
      v.axios.post(api.post_erpCommonSettingParam_queryMerchantByParamKeys, ['ymsDistributorCurrency']).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data.length > 0) {
            data.map((item) => {
              if (item.paramKey === 'ymsDistributorCurrency') {
                v.currency = item.paramValue;
                if (item.paramValue !== 'CNY') {
                  v.systemCurrencyData(item.paramValue);
                }
              }
            });
          }
        }
      });
    },
    // 处理汇率计算数据
    handleEexchangeRate(data, sum) {
      let v = this;
      v.currentExchangeRate = '';
      v.actualAmount = '';
      if (data) {
        let targetCurrencyCode = data.targetCurrencyCode;
        let merchantExchangeRate = '';
        if (data.rateType !== 1) {
          merchantExchangeRate = amountHandel(1 / data.merchantExchangeRate, 4);
        } else {
          merchantExchangeRate = data.merchantExchangeRate;
        }
        let value = sum ? sum : v.amount[v.activeAmountType];
        let actualAmount = amountHandel((value * merchantExchangeRate), 4);
        let space = ' ';
        let currencyName = currencyNameCode(v.currency);
        v.currentExchangeRate = `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005891')} CNY = ${merchantExchangeRate}${space}${targetCurrencyCode}`;
        v.actualAmount = `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005892')} ${currencyName}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003776')} ${actualAmount}${space}${v.currency}`;
      }
    },
    // 上传支付流水图片
    uploadSuccess(response, file, fileList) {
      let v = this;
      if (response.code === 0) {
        v.formInline.imagePaths = [...v.formInline.imagePaths, response.datas[0]].slice(0, 5);
        v.$Message.success(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000251')}`);
      } else {
        v.$Message.error(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000457')}`);
      }
    },
    // 校验文件格式
    handleFormatError(file) {
      let v = this;
      v.$Message.error({
        content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001477')}`,
        duration: 4
      });
    },
    // 限制上传的文件不能超过5M
    handleMaxSize(file) {
      let v = this;
      v.$Message.error({
        content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001478')}`,
        duration: 4
      });
    },
    // 删除图片
    delProductImages(index) {
      this.formInline.imagePaths.splice(index, 1);
      this.$forceUpdate();
    },
    // 选择支付渠道
    changeChannel(value) {
      this.accountList = [];
      if (value) {
        let newList = this.paymentChannelsList.filter((item) => item.channel === value);
        this.accountList = this.uniqueFunc(newList, 'account');
        this.formInline.account = null;
        if (this.accountList.length > 0) {
          this.formInline.account = this.accountList[0].account;
          this.changeAccount(this.formInline.account);
        }
      }
    },
    // 选择账户
    changeAccount(value) {
      let totalAmount = this.getRechargeAmount(this.activeAmountType, this.formInline.totalAmount);
      let list = this.accountList.filter((item) => item.account === value);
      if (list.length > 0 && totalAmount) {
        let query = {
          price: Number(totalAmount),
          priceCurrency: this.currencyState,
          targetCurrency: list[0].currency
        };
        getCurrencyConversion(query).then((item) => {
          this.formInline.receiveTotalPrice = amountHandel(item.targetPrice);
          this.formInline.targetCurrency = item.targetCurrency;
        });
      }
    },
    // 查看完整消息
    viewCompleteMessage() {
      let list = this.accountList.filter((item) => item.account === this.formInline.account);
      this.$refs['completeAccountInfo'].initCompleteAccountInfoData(list[0]);
    },
    // 切换支付选择
    paymentTypeChange() {
      this.activeAmountType = 0;
      this.formInline.totalAmount = this.getRechargeAmount(this.activeAmountType);
      this.formInline.payType = 'alipay';
      this.formInline.currency = 'CNY';
      this.formInline.targetCurrency = null;
      this.formInline.receiveTotalPrice = null;
      this.formInline.imagePaths = [];
      clearFormFieldValidate(this.$refs.formInline, ['totalAmount', 'channel', 'account']);
    },
    // 重置数据
    resetData() {
      if (this.$refs['formInline']) {
        this.$refs['formInline'].resetFields();
      }
      this.activeAmountType = 0;
      this.formInline.totalAmount = '';
      this.formInline.payType = 'alipay';
      this.formInline.currency = 'CNY';
      this.formInline.targetCurrency = null;
      this.formInline.receiveTotalPrice = null;
      this.formInline.imagePaths = [];
      this.activeAmountType = 0;
      this.currency = '';
      this.currencyTalg = false;
      this.currentExchangeRate = '';
      this.actualAmount = '';
      this.selectCurrencyData = null;
      this.offlinePaymentFlag = false;
    },
    // 监听弹窗
    rechargeChange(value) {
      if (!value) {
        this.resetData();
      }
    }
  },
  components: {
    completeAccountInfoModal
  },
};
</script>

<style lang="less" scoped>
.amount-list {
  width: 100%;
}

.other-amount {
  min-width: 173px;

  /deep/ .ivu-input, /deep/ .ivu-input-icon {
    line-height: 46px;
    height: 46px;
  }
}

.other-box {
  padding: 5px 10px;
  display: inline-block;
  border-radius: 5px;
  border: 1px solid #ddd;
  transition: 0.15s ease-out;
  cursor: pointer;
}

.other-box:hover, .amount-box:hover, .active-box {
  color: #FD5425;
  border-color: #FD5425 !important;
  box-shadow: 0 0 5px #ff22008c;
}

.amount-box {
  display: inline-block;
  border: 1px solid #ddd;
  padding: 6px 20px;
  border-radius: 5px;
  margin-right: 12px;
  transition: 0.15s ease-out;
  cursor: pointer;
}

.alipay-logo {
  float: right;
  margin-top: -4px;
}

.payoneer-logo {
  float: right;
  margin-top: 2px;
}

/deep/ .rechargeStyles {
  .upload_styles {
    .ivu-upload.ivu-upload-drag {
      width: 100px;
      height: 100px;
    }

    .upload_icon_box {
      width: 100px;
      height: 100px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-content: center;
    }
  }

  .img_style {
    width: 100px;
    height: 100px;
    margin-right: 12px;
    position: relative;

    img {
      width: 100%;
      height: 100%;
      display: inline-block;
      object-fit: cover;
      vertical-align: middle;
      border: 1px solid #ddd;
      border-radius: 5px;
    }

    &:hover .del-icon {
      display: block;
      z-index: 1000;
    }
  }

  .del-icon {
    font-size: 24px;
    position: absolute;
    top: -10px;
    right: -10px;
    cursor: pointer;
    display: none;

    &:hover {
      color: #ff0000;
    }
  }

  .radio_styles label.ivu-radio-group-item {
    position: relative;
    top: 1px;
  }
}
</style>
